import { providerLabel } from "./ai-pwa";
// インボックス（分類前タスクの受け皿）の判定と提案マージ。依存ゼロの純関数。
// インボックス = project_id が NULL か孤児（プロジェクト一覧に無い）の未完了タスク
// （laneCore の未分類レーンと同じ判定。分類済み/未分類の状態フラグは持たない）。

export interface InboxTaskLike {
  id: string;
  completed: boolean;
  deleted: boolean;
  projectId?: string | null;
  /** G1: ゴール紐付きタスクはインボックス対象外（ゴール管理で扱う） */
  goalId?: string | null;
  createdAt: string;
}

export interface SuggestionLike {
  taskId: string;
  projectId: string | null;
  owner: string;
  confidence: number;
}

export const OWNER_LABELS: Record<string, string> = {
  taiga: "たいがさん",
  codex: providerLabel("codex"),
  claude: providerLabel("claude"),
  grok: "Grok",
  hermes: "Hermes",
};

export function ownerLabel(owner: string): string {
  return OWNER_LABELS[owner] ?? owner;
}

export function isInboxTask(task: InboxTaskLike, knownProjectIds: Set<string>): boolean {
  if (task.completed || task.deleted) return false;
  // G1: ゴール紐付きタスクはゴール管理側で扱うためインボックスから除外
  if (task.goalId) return false;
  return !task.projectId || !knownProjectIds.has(task.projectId);
}

export function inboxTasks<T extends InboxTaskLike>(tasks: T[], projectIds: Set<string>): T[] {
  return tasks
    .filter((t) => isInboxTask(t, projectIds))
    .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)); // 新しい順
}

export interface InboxRow<T extends InboxTaskLike> {
  task: T;
  suggestion: SuggestionLike | null;
}

export function mergeSuggestions<T extends InboxTaskLike>(
  tasks: T[],
  suggestions: SuggestionLike[]
): InboxRow<T>[] {
  const byTask = new Map(suggestions.map((s) => [s.taskId, s]));
  return tasks.map((task) => ({ task, suggestion: byTask.get(task.id) ?? null }));
}
